import { createSlice, type PayloadAction } from '@reduxjs/toolkit'

export type AuthState = {
  isAuthenticated: boolean
  userEmail?: string
}

const initialState: AuthState = {
  isAuthenticated: false,
}

const authSlice = createSlice({
  name: 'auth',
  initialState,
  reducers: {
    setAuthenticated(state, action: PayloadAction<{ isAuthenticated: boolean; userEmail?: string }>) {
      state.isAuthenticated = action.payload.isAuthenticated
      state.userEmail = action.payload.userEmail
    },
    clearAuth(state) {
      state.isAuthenticated = false
      state.userEmail = undefined
    },
  },
})

export const { setAuthenticated, clearAuth } = authSlice.actions
export default authSlice.reducer
